export const API_END_POINTS = {
  AASHTO_CLASSIFICATION: "/soil_classifier/aashto_classification",
  USCS_CLASSIFICATION: "/soil_classifier/uscs_classification",
  ULTIMATE_BEARING_CAPACITY: "/bearing_capacity/ubc",
  ALLOWABLE_BEARING_CAPACITY: "/bearing_capacity/abc",
  SPT_N_DESIGN: "/spt/n_design",
  ENERGY_CORRECTION: "/spt/energy_correction",
  OVERBURDEN_PRESSURE_CORRECTION: "/spt/overburden_pressure_correction",
  DILATANCY_CORRECTION: "/spt/dilatancy_correction",
  USER: "/user",
  FEEDBACK: "/feedback",
};
